/** Karen Ruimy admin dashboard branding (web console for operators). */
export const BRAND_ADMIN_FULL_NAME = 'Karen Ruimy Admin';
/** Compact mark for sidebar / collapsed logo (Karen Ruimy). */
export const BRAND_ADMIN_LOGO_MARK = 'KR';
export const BRAND_ADMIN_LOGIN_TAGLINE =
  'Manage app content, members, and settings for Karen Ruimy.';
